// assets/dag-sticky-atc.js
document.addEventListener('DOMContentLoaded', () => {
  const sticky = document.getElementById('DagStickyATC');
  if (!sticky) return;

  // 1) 追従バーを body 直下に移動
  try {
    document.body.appendChild(sticky);
  } catch (e) {
    console.warn('dag-sticky-atc: append to body failed', e);
  }

  sticky.hidden = false;

  // 2) 本体の add-to-cart フォーム＆数量 input
  const productForm =
    document.querySelector('product-form form[action^="/cart/add"]') ||
    document.querySelector('form[data-type="add-to-cart-form"]') ||
    document.querySelector('form[id^="product-form-"][action^="/cart/add"]') ||
    document.querySelector('form[action^="/cart/add"]');

  const mainQtyInput =
    document.querySelector('.product-form__quantity input[name="quantity"]') ||
    document.querySelector('quantity-input input[name="quantity"]');

  // 3) 追従バー側の数量 UI
  const stickyQtyInput = sticky.querySelector('.dag-sticky-atc__qty-input');
  const minusBtn = sticky.querySelector('.dag-sticky-atc__qty-btn--minus');
  const plusBtn = sticky.querySelector('.dag-sticky-atc__qty-btn--plus');

  if (!stickyQtyInput) {
    console.warn('dag-sticky-atc: sticky quantity input not found');
    return;
  }

  // エラー表示要素（任意）
  const errorEl = sticky.querySelector('.dag-sticky-atc__error');

  // 4) maxQty を決定（Liquid からの data-max-qty を優先）
  const maxAttrFromSticky = sticky.getAttribute('data-max-qty');
  const maxAttrFromMain = mainQtyInput ? mainQtyInput.getAttribute('max') : null;
  const maxAttr = maxAttrFromSticky || maxAttrFromMain;
  const maxQty = maxAttr ? parseInt(maxAttr, 10) : null;

  if (maxQty !== null && !Number.isNaN(maxQty)) {
    stickyQtyInput.setAttribute('max', String(maxQty));
    if (mainQtyInput) mainQtyInput.setAttribute('max', String(maxQty));
  }

  // Dawn 風エラー表示
  const showError = (message) => {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
    window.clearTimeout(showError._timerId);
    showError._timerId = window.setTimeout(() => {
      errorEl.hidden = true;
    }, 2500);
  };

  // 値を 1〜max の範囲に収める
  const normalize = (value, showErrorFlag = false) => {
    let v = parseInt(value || '1', 10);
    if (Number.isNaN(v) || v < 1) v = 1;

    if (maxQty !== null && !Number.isNaN(maxQty) && v > maxQty) {
      v = maxQty;
      if (showErrorFlag) {
        showError(`在庫は最大 ${maxQty} 点までです。`);
      }
    }
    return v;
  };

  // 本体と同期
  const syncToMain = (value) => {
    if (mainQtyInput) {
      mainQtyInput.value = String(value);
    }
  };

  // 初期値を揃える
  const initial = normalize(
    (mainQtyInput && mainQtyInput.value) || stickyQtyInput.value
  );
  stickyQtyInput.value = initial;
  syncToMain(initial);

  // 数量変更処理
  const changeQty = (delta, showErrorFlag = false) => {
    const current = normalize(stickyQtyInput.value, false);
    const next = normalize(current + delta, showErrorFlag);
    stickyQtyInput.value = next;
    syncToMain(next);
  };

  // 手入力
  stickyQtyInput.addEventListener('change', () => {
    const v = normalize(stickyQtyInput.value, true);
    stickyQtyInput.value = v;
    syncToMain(v);
  });

  // ボタン
  if (minusBtn) {
    minusBtn.addEventListener('click', () => changeQty(-1, false));
  } else {
    console.warn('dag-sticky-atc: minus button not found');
  }

  if (plusBtn) {
    plusBtn.addEventListener('click', () => changeQty(1, true));
  } else {
    console.warn('dag-sticky-atc: plus button not found');
  }

  console.log('dag-sticky-atc init', {
    productForm,
    mainQtyInput,
    stickyQtyInput,
    minusBtn,
    plusBtn,
    maxQty,
  });

  // 5) 「カートに入れる」クリック → 本体フォーム submit
  const stickyButton = sticky.querySelector('.dag-sticky-atc__button');
  if (stickyButton && productForm) {
    stickyButton.addEventListener('click', (event) => {
      if (stickyButton.disabled) return;

      event.preventDefault();

      const v = normalize(stickyQtyInput.value, false);
      stickyQtyInput.value = v;
      syncToMain(v);

      if (typeof productForm.requestSubmit === 'function') {
        productForm.requestSubmit();
      } else {
        productForm.submit();
      }
    });
  } else {
    console.warn('dag-sticky-atc: sticky button or productForm not found', {
      stickyButton,
      productForm,
    });
  }
});
